import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RefuelIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RefuelGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.94072 1.5C3.66458 1.5 3.44072 1.72386 3.44072 2V18.051H14.2775V2C14.2775 1.72386 14.0536 1.5 13.7775 1.5H3.94072ZM15.2775 18.051V2C15.2775 1.17157 14.6059 0.5 13.7775 0.5H3.94072C3.11229 0.5 2.44072 1.17157 2.44072 2V18.051H1.8999C1.07148 18.051 0.399902 18.7226 0.399902 19.551V20C0.399902 20.8284 1.07147 21.5 1.8999 21.5H15.8999C16.7283 21.5 17.3999 20.8284 17.3999 20V19.551C17.3999 18.7226 16.7283 18.051 15.8999 18.051H15.2775ZM1.8999 19.051C1.62376 19.051 1.3999 19.2749 1.3999 19.551V20C1.3999 20.2761 1.62376 20.5 1.8999 20.5H15.8999C16.176 20.5 16.3999 20.2761 16.3999 20V19.551C16.3999 19.2749 16.176 19.051 15.8999 19.051H1.8999ZM5.98154 3.54082C5.70539 3.54082 5.48153 3.76467 5.48153 4.04082V6.93878C5.48153 7.21492 5.70539 7.43878 5.98153 7.43878H11.7366C12.0128 7.43878 12.2366 7.21492 12.2366 6.93878V4.04082C12.2366 3.76467 12.0128 3.54082 11.7366 3.54082H5.98154ZM4.48153 4.04082C4.48153 3.21239 5.15311 2.54082 5.98154 2.54082H11.7366C12.5651 2.54082 13.2366 3.21239 13.2366 4.04082V6.93878C13.2366 7.7672 12.5651 8.43878 11.7366 8.43878H5.98153C5.15311 8.43878 4.48153 7.7672 4.48153 6.93878V4.04082Z"
        fill="#696969"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8317 0.693053C17.0012 0.475079 17.3154 0.435812 17.5333 0.605347L19.9181 2.46014C20.853 3.18731 21.3998 4.30539 21.3998 5.48982V14.0612C21.3998 15.4645 20.2623 16.6021 18.859 16.6021C17.4558 16.6021 16.3182 15.4645 16.3182 14.0612V7.12247C16.3182 6.49692 15.8111 5.98982 15.1855 5.98982V4.98982C16.3634 4.98982 17.3182 5.94464 17.3182 7.12247V14.0612C17.3182 14.9122 18.008 15.6021 18.859 15.6021C19.71 15.6021 20.3998 14.9122 20.3998 14.0612V6.57374L19.231 5.79455C18.8137 5.51635 18.5631 5.048 18.5631 4.54647V2.67314L16.9194 1.3947C16.7014 1.22516 16.6622 0.911026 16.8317 0.693053ZM19.5631 3.47745V4.54647C19.5631 4.71365 19.6466 4.86976 19.7857 4.9625L20.3973 5.37021C20.3672 4.65428 20.0674 3.97891 19.5631 3.47745Z"
        fill="#696969"
      />
    </svg>
  );
};

export default RefuelIcon;
